import { render, staticRenderFns } from "./newIntegralRemind.vue?vue&type=template&id=07eb8c70&scoped=true&"
import script from "./newIntegralRemind.vue?vue&type=script&lang=js&"
export * from "./newIntegralRemind.vue?vue&type=script&lang=js&"
import style0 from "./newIntegralRemind.vue?vue&type=style&index=0&id=07eb8c70&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07eb8c70",
  null
  
)

export default component.exports